
function handleRequestAQuoteOnCollectionPage(button){

    const quoteData = (JSON.parse(localStorage.getItem(QUOTE_CART_LOCAL_STORAGE_ID)) || []).reverse();
    const list = document.getElementById('list_items');

    const variant = getVariant(button);

    const form = button?.closest('.form-container');

    const productData = button.getAttribute('data-product') ? JSON.parse(button.getAttribute('data-product')) : null;

    if(!productData || !variant || !form){
        return;
    }

    const quantity = parseInt(form.querySelector('select')?.value) || 1;

    const variantId = String(variant.id);
    const productId = String(productData.id);

    const existingItemIndex = quoteData.findIndex(item => 
        item.productId === productId && item.variantId === variantId
    );

    if (existingItemIndex !== -1) {
        // Item exists, just increase the quantity
        quoteData[existingItemIndex].quantity += quantity;
    } else {

        // If price is already a number (from Typesense), it's in dollars
        // If price is a string, strip formatting and convert from cents
        const isPriceNumber = typeof variant.price === 'number';
        let variantPrice = isPriceNumber ? variant.price : (Number(String(variant.price).replace(/[",\.]/g, '')) || 0);

        // console.log('Variant Price:', variantPrice, variant.price);

        let mainProduct = {};

        mainProduct.productId = productId;
        mainProduct.variantId = variantId;
        mainProduct.quantity = quantity;
        mainProduct.hidePrice = variant.hide_price === true;
        mainProduct.usd_price = isPriceNumber
            ? (variantPrice / (Shopify?.currency?.rate || 1))
            : (variantPrice / (Shopify?.currency?.rate || 1)) / 100;
        mainProduct.productData = {
        title: productData.title,
        handle: productData.handle,
        variantTitle: variant.title,
        featured_image: productData.featured_image,
        variantImage: variant.featured_image,
        tags: productData.tags || [],
        variants: [
                    {
                    id: variantId,
                    usd_price: isPriceNumber
                        ? (variantPrice / (Shopify?.currency?.rate || 1))
                        : (variantPrice / (Shopify?.currency?.rate || 1)) / 100,
                    title: variant.title,
                    featured_image: {
                            src: variant.featured_image,
                            alt: productData.title
                        }
                    }
            ]
        }

        quoteData.push(mainProduct);

        // console.log('Added new item to quote:', mainProduct);

    }

    localStorage.setItem(QUOTE_CART_LOCAL_STORAGE_ID, JSON.stringify(quoteData));

    if (list) list.innerHTML = createQuoteHtml('Remove', true);
    localStorage.setItem('quote_page_render_flag', true);

    setTimeout(() => {
    const quoteToggleBtn = document.querySelector('.header-cart-quote');
    if (quoteToggleBtn) {
        quoteToggleBtn.click();
    }
    }, 300);


    // console.log(mainProduct);
    

    // console.log('Data:', quantity, variantId, productId, quoteData);
    
    // addProductToQuote(quoteData, productId, variantId, quantity, mainProduct);
    

  

}


function handleAddToCartOnCollectionPage(button){
    
    const variant = getVariant(button);

    // console.log("button clicked!!!");

    if(!variant){
        return;
    }

    //console.log('Add to cart variant ID:', variantID);

    const quantitySelect = button.closest('.form-container')?.querySelector('select');
    const quantity = quantitySelect ? parseInt(quantitySelect.value) : 1;

    const items = [{
        id: variant.id,
        quantity: quantity
    }];

    if(items){
        collectionPageAddToCart(items)
        .then(message => {
        // const buttonText = button.innerHTML;
        if(message == 'Success'){
            // button.innerHTML = "Item Added!"
            setTimeout(() => {
            if (typeof openCart === 'function') {
                openCart();
                return;
            }

            const cartToggleButton = document.querySelector('.header-cart-cta');
            if (cartToggleButton) {
                cartToggleButton.click();
            }
            }, 300);
            
            // setTimeout(() => button.innerHTML = buttonText, 2000);
        }
        })
        .catch(error => {
        // handleInlinePopup('error', `${error.message}:${error.description}`);
        console.error('Error adding to cart:', error);
        })
    }
}

function getVariant(button) {
    // Get the main parent card
    const card = button.closest('.collection-page-card');
    if (!card) {
        console.error('Collection page card not found');
        return null;
    }

    // Get variants data from data-variants attribute
    const variantsData = card.getAttribute('data-variants');
    if (!variantsData) {
        console.error('Variants data not found');
        return null;
    }

    let variants;
    try {
        variants = JSON.parse(variantsData);
    } catch (error) {
        console.error('Error parsing variants data:', error);
        return null;
    }

    // Get the option container
    const optionContainer = card.querySelector('.collection-option-container');
    if (!optionContainer) {
        console.error('Option container not found');
        return null;
    }

    // Get all checked radio buttons
    const checkedRadios = optionContainer.querySelectorAll('input[type="radio"]:checked');
    
    // Build selected options object
    const selectedOptions = {};
    checkedRadios.forEach(radio => {
        const position = radio.getAttribute('data-option-position');
        const value = radio.value;
        if (position && value) {
            selectedOptions[`option${position}`] = value;
        }
    });

    // console.log('Selected options:', selectedOptions);

    // Find matching variant
    const matchingVariant = variants.find(variant => {
        // Check if all selected options match this variant
        return Object.keys(selectedOptions).every(optionKey => {
            return variant[optionKey] === selectedOptions[optionKey];
        });
    });

    if (matchingVariant) {
        // console.log('Matching variant found:', matchingVariant);
        return matchingVariant;
    } else {
        console.error('No matching variant found for selected options:', selectedOptions);
        return null;
    }
}



(function initFindifyWatcher() {
  let currentRoot = null;
  let currentObserver = null;

  const bodyObserver = new MutationObserver(() => {
    const newRoot = document.querySelector('#findify-search');

    // If Findify root is replaced or inserted
    if (newRoot && newRoot !== currentRoot) {
      currentRoot = newRoot;

      console.log('Findify root detected / replaced');

      // Cleanup old observer
      if (currentObserver) {
        currentObserver.disconnect();
      }

      attachGridObserver(currentRoot);
      myCustomFunction('ready');
    }
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  function attachGridObserver(root) {
    let raf;

    currentObserver = new MutationObserver(mutations => {
      const hasRelevantChange = mutations.some(m =>
        m.addedNodes.length || m.removedNodes.length
      );

      if (!hasRelevantChange) return;

      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        myCustomFunction('afterRender');
      });
    });

    currentObserver.observe(root, {
      childList: true,
      subtree: true
    });
  }
})();


function myCustomFunction(type) {
  console.log('Findify updated – my function ran', type);
  // your logic here
}

// collection add to  cart

async function collectionPageAddToCart(items) {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    return fetch("/cart/add.js", {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
        items: items
    }),
    credentials: 'same-origin'
    })
    .then(response => {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));

    if (response.ok) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
        }));
        return 'Success';

    } else {
        return response.json().then(function(content) {
        const errorMsg = content['description'];
        throw new Error(errorMsg);
        });
    }
    })
    .catch(function(error) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
}

// function to handle quantity change
function handleQuantityOnChange(selectElement) {
    const quantityContainer = selectElement.closest('.quantity');

    if (!quantityContainer) {
        console.log('Quantity container not found');
        return;
    }

    const quantityValueElement = quantityContainer.querySelector('.quantity-value-to-show');

    if (!quantityValueElement) {
        console.log('Quantity value display element not found');
        return;
    }

    quantityValueElement.textContent = selectElement.value;

}

function parseCardVariants(card) {
    const variantsData = card.getAttribute('data-variants');
    if (!variantsData) {
        return [];
    }

    try {
        return JSON.parse(variantsData);
    } catch (error) {
        console.log('Error parsing variants data:', error);
        return [];
    }
}

function getCardOptionInputs(card) {
    return card.querySelectorAll('.collection-option-container input[type="radio"][data-option-position]');
}

function getCardSelectedOptions(card) {
    const selectedOptions = {};
    getCardOptionInputs(card).forEach((radio) => {
        if (!radio.checked) return;

        const position = Number(radio.getAttribute('data-option-position'));
        if (!position || !radio.value) return;

        selectedOptions[`option${position}`] = radio.value;
    });

    return selectedOptions;
}

function normalizeOptionValue(value) {
    return String(value || '').trim().toLowerCase();
}

function matchesSelectionPrefix(variant, selection, maxPosition) {
    for (let position = 1; position <= maxPosition; position += 1) {
        const optionKey = `option${position}`;
        if (!(optionKey in selection)) continue;
        if (variant[optionKey] !== selection[optionKey]) return false;
    }

    return true;
}

function isOptionValueAvailable(variants, selectedOptions, position, value) {
    const optionKey = `option${position}`;
    const candidateSelection = { ...selectedOptions, [optionKey]: value };

    return variants.some((variant) => {
        if (!variant.available) return false;
        if (variant[optionKey] !== value) return false;
        return matchesSelectionPrefix(variant, candidateSelection, position);
    });
}

function applyOptionAvailabilityState(card, variants, selectedOptions) {
    getCardOptionInputs(card).forEach((radio) => {
        const position = Number(radio.getAttribute('data-option-position'));
        if (!position) return;

        const isAvailable = isOptionValueAvailable(variants, selectedOptions, position, radio.value);
        radio.disabled = !isAvailable;

        const swatch = radio.closest('.block-swatch');
        if (swatch) {
            swatch.classList.toggle('block-swatch--disabled', !isAvailable);
        }
    });
}

function normalizeSelectedOptions(card, variants) {
    const optionInputs = Array.from(getCardOptionInputs(card));
    const positions = [...new Set(
        optionInputs
            .map((radio) => Number(radio.getAttribute('data-option-position')))
            .filter(Boolean)
    )].sort((a, b) => a - b);

    const normalizedSelection = {};

    positions.forEach((position) => {
        const radios = optionInputs.filter((radio) => Number(radio.getAttribute('data-option-position')) === position);
        const checkedRadio = radios.find((radio) => radio.checked && !radio.disabled);
        let selectedRadio = checkedRadio;

        if (!selectedRadio) {
            selectedRadio = radios.find((radio) => isOptionValueAvailable(variants, normalizedSelection, position, radio.value));
        }

        if (!selectedRadio) return;

        radios.forEach((radio) => {
            radio.checked = radio === selectedRadio;
        });

        normalizedSelection[`option${position}`] = selectedRadio.value;
    });

    return normalizedSelection;
}

function findMatchingVariantForSelection(variants, selectedOptions) {
    return variants.find((variant) => {
        return Object.keys(selectedOptions).every((optionKey) => variant[optionKey] === selectedOptions[optionKey]);
    }) || null;
}

function refreshCollectionCardVariantState(card) {
    if (!card) return null;

    const variants = parseCardVariants(card);
    if (!variants.length) return null;

    let selectedOptions = getCardSelectedOptions(card);
    applyOptionAvailabilityState(card, variants, selectedOptions);

    selectedOptions = normalizeSelectedOptions(card, variants);
    applyOptionAvailabilityState(card, variants, selectedOptions);

    const matchingVariant = findMatchingVariantForSelection(variants, selectedOptions);
    if (matchingVariant) {
        updateVariantDisplay(card, matchingVariant);
    }

    return matchingVariant;
}

function initializeCollectionCardVariantStates(root = document) {
    const cards = root.querySelectorAll('.collection-page-card[data-variants]');
    cards.forEach((card) => {
        refreshCollectionCardVariantState(card);
    });
}

function handleOptionChange(radioElement) {
    const optionContainer = radioElement.closest('.collection-option-container');
    if (!optionContainer) {
        console.log('Option container not found');
        return null;
    }

    const card = optionContainer.closest('.collection-page-card');
    if (!card) {
        console.log('Collection page card not found');
        return null;
    }

    return refreshCollectionCardVariantState(card);
}

function updateVariantDisplay(card, variant) {
    const image = card.querySelector('.card-image img');

    if (image && variant.featured_image) {
        image.setAttribute('src', variant.featured_image);

        const separator = variant.featured_image.includes('?') ? '&' : '?';
        const newSrcset = `${variant.featured_image}${separator}width=200 200w, ${variant.featured_image}${separator}width=250 250w`;
        image.setAttribute('srcset', newSrcset);

        if (variant.featured_image_alt || variant.title) {
            image.setAttribute('alt', variant.featured_image_alt || variant.title);
        }
    }

    const sku = card.querySelector('.variant-sku');
    if (sku && variant.sku) {
        sku.textContent = variant.sku;
    }
    const priceHTMLContainers = card.querySelectorAll('.price-container');
    if (priceHTMLContainers) {
        if (variant.hide_price) {
            const isAdminCard = card.hasAttribute('data-admin-product-card');
            priceHTMLContainers.forEach(container => {
                if (isAdminCard) {
                    container.innerHTML = (variant.priceHTML || '') + '<span class="text-xs font-medium text-amber-600 bg-amber-50 border border-amber-200 rounded px-1.5 py-0.5 whitespace-nowrap">This price is Hidden</span>';
                } else {
                    container.innerHTML = '';
                }
            });
            card.setAttribute('data-hide-price', 'true');
        } else if (variant.priceHTML) {
            priceHTMLContainers.forEach(container => {
                container.innerHTML = variant.priceHTML;
            });
            card.setAttribute('data-hide-price', 'false');
        }
    }
    const addToCartButton = card.querySelector('.add-to-cart-btn');
    const requestQuoteButton = card.querySelector('.request-quote-btn');

    if (variant.hide_price) {
        if(addToCartButton) addToCartButton.disabled = true;
        if(requestQuoteButton) requestQuoteButton.disabled = false;
    } else if (!variant.available) {
        if(addToCartButton) addToCartButton.disabled = true;
        if(requestQuoteButton) requestQuoteButton.disabled = true;
    } else {
        if(addToCartButton) addToCartButton.disabled = false;
        if(requestQuoteButton) requestQuoteButton.disabled = false;
    }

    const compareCheckbox = card.querySelector('.compare-checkbox');

    if (compareCheckbox) {
        compareCheckbox.setAttribute('data-product-variant', variant.id);
        if(variant.featured_image){
            compareCheckbox.setAttribute('data-product-image', variant.featured_image);
        }
    }

    if (variant.id) {
        card.querySelectorAll('a[href*="/products/"]:not([target="_blank"])').forEach(link => {
            try {
                const url = new URL(link.href, window.location.origin);
                url.searchParams.set('variant', variant.id);
                link.href = url.pathname + '?' + url.searchParams.toString();
            } catch(e) {}
        });

        const aprLink = card.querySelector('[data-apr-link]');
        if (aprLink) {
            aprLink.href = `https://admin.shopify.com/store/bayland/apps/auto-pricing-rules-v2/app/variant-with-apr?shopify_variant_id=${encodeURIComponent(variant.id)}`;
        }
    }

}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initializeCollectionCardVariantStates(document);
    }, { once: true });
} else {
    initializeCollectionCardVariantStates(document);
}

const collectionCardObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        if (!mutation.addedNodes || !mutation.addedNodes.length) continue;

        mutation.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;

            if (node.matches && node.matches('.collection-page-card[data-variants]')) {
                refreshCollectionCardVariantState(node);
                return;
            }

            if (node.querySelectorAll) {
                initializeCollectionCardVariantStates(node);
            }
        });
    }
});

collectionCardObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
});
    
